import data from "../../../../../packages/react/src/drafts/MarkdownEditor/MarkdownEditor.docs.json";
import * as React from 'react';
export default {
  data,
  React
};